import { COLUMN_TYPES } from '../../../components/UI/GenericTable/Const';

export const RELEASE_SELECTION_TABLE = {
  columns: [
    { name: 'ReleaseName', title: 'Release Name' },
    { name: 'ReleaseDate', title: 'Release Date', formatToDate: true },
    { name: 'ReleaseOwner', title: 'Release Owner' },
    {
      name: 'ReleaseDeletionDate',
      title: 'Expected Deletion Date',
      formatToDate: true,
    },
    { name: 'details', title: 'Details', type: COLUMN_TYPES.ACTION },
    // { name: 'knownIssues', title: 'Known Issues', type: COLUMN_TYPES.ACTION },
    // { name: 'whatsNew', title: "What's New", type: COLUMN_TYPES.ACTION },
  ],
  filteringStateColumnExtensions: [
    { columnName: 'ReleaseName', filteringEnabled: true },
    { columnName: 'ReleaseDate', filteringEnabled: true },
    { columnName: 'ReleaseOwner', filteringEnabled: true },
    { columnName: 'ReleaseDeletionDate', filteringEnabled: true },
    { columnName: 'details', filteringEnabled: false },
  ],
  tableColumnExtensions: [
    { columnName: 'ReleaseName', width: 'auto' },
    { columnName: 'ReleaseDate', width: '12rem' },
    { columnName: 'ReleaseOwner', width: '12rem' },
    { columnName: 'ReleaseDeletionDate', width: '12rem' },
    { columnName: 'details', width: '5rem' },
  ],
  tableTitle: 'Release Selection',
  tableKey: 'releaseSelection',
};
